import { render, staticRenderFns } from "./TextareaBox.vue?vue&type=template&id=472c22ad&scoped=true&"
import script from "./TextareaBox.vue?vue&type=script&lang=js&"
export * from "./TextareaBox.vue?vue&type=script&lang=js&"
import style0 from "./TextareaBox.vue?vue&type=style&index=0&id=472c22ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c22ad",
  null
  
)

export default component.exports